module.exports = __webpack_public_path__ + "img/47-daec0b.png";